export class VistaCouponProdotti {

    constructor(public CouponID: number,
                public Name: string,
                public Sku: string,
                public ProductID: number) { }

}
